<script setup lang="ts"></script>

<template>
  <div class="pa-4 text-center legal-conditions">
    <i18n-t keypath="vue.legal-conditions.text">
      <template #terms>
        <a
          href="https://starmind.com/terms-of-use"
          target="_blank"
          class="text-primary text-decoration-underline"
          >{{ $t('legal-conditions.link.user-terms.label') }}</a
        >
      </template>
      <template #privacy>
        <a
          href="https://starmind.com/privacy-policy"
          target="_blank"
          class="text-primary text-decoration-underline"
          >{{ $t('legal-conditions.link.privacy-policy.label') }}</a
        >
      </template>
    </i18n-t>
  </div>
</template>

<style scoped>
/* Caption/12/Regular design token: 12px / 16px line-height / 0 letter-spacing */
.legal-conditions {
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0 !important;
}
</style>
